export { Icon } from './Icon';
export type { IconType } from './Icon';